import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d910d5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "result-list" }

import { computed, ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import ListSort from './components/ListSort.vue'
import ProductListGrid from './components/ProductListGrid.vue'
import ShopListGrid from './components/ShopListGrid.vue'
import { goodsFootprintProduct, goodsFootprintShop } from '@/apis/usercenter'
import { useRequest } from '@/util/useLoading'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tabList = [
  { label: t('我看过的商品'), value: 0, api: goodsFootprintProduct },
  { label: t('我看过的店铺'), value: 1, api: goodsFootprintShop }
]

const tab = ref()

const sortTypes = computed(() => {
  return tab.value
    ? [
      { label: t('时间'), bothway: true, name: 'update_time' }
    ]
    : [
      { label: t('时间'), bothway: true, name: 'update_time' },
      { label: t('价格'), bothway: true, name: 'product_sell_price' }
    ].fort()
})

const [loading, api] = useRequest(() => {
  const row: any = tab.value ? tabList.find(e => e.value === tab.value) : tabList[0]
  return row.api(params.value).then((res: any) => {
    if (res.success) {
      num.value++
      requestAnimationFrame(() => {
        data.value = res.data
      })
    }
  })
})

const mixin = (obj1: any, obj2: any) => {
  Object.entries(obj1).forEach(([k, v]) => {
    obj2[k] = obj2[k] ?? v
  })
  return obj2
}

const route = useRoute()
const name = route.name
const params: any = ref()
const data: any = ref({})
const num = ref(0)

watch(params, () => api(), { deep: true })
watch(
  route,
  (v) => {
    if (v.name !== name) return
    tab.value = v.query?.tab ? Number(route.query.tab) : 0
    const query = { ...v.query }
    if (query.descendOrder) {
      query.descendOrder = JSON.parse(query.descendOrder.toString())
    }
    if (query.tab) {
      delete query.tab
    }
    params.value = mixin(
      {
        pageNum: 1,
        pageSize: 50
      },
      query
    )
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ListSort, {
      params: params.value,
      sortTypes: _unref(sortTypes),
      tabList: tabList
    }, null, 8, ["params", "sortTypes"]),
    (!tab.value)
      ? (_openBlock(), _createBlock(ProductListGrid, {
          pageNum: params.value.pageNum,
          "onUpdate:pageNum": _cache[0] || (_cache[0] = ($event: any) => ((params.value.pageNum) = $event)),
          pageSize: params.value.pageSize,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((params.value.pageSize) = $event)),
          data: data.value,
          key: num.value,
          behaviorChannel: 7,
          type: "look",
          onSuccess: _cache[2] || (_cache[2] = ($event: any) => (_unref(api)()))
        }, null, 8, ["pageNum", "pageSize", "data"]))
      : _createCommentVNode("", true),
    (tab.value)
      ? (_openBlock(), _createBlock(ShopListGrid, {
          pageNum: params.value.pageNum,
          "onUpdate:pageNum": _cache[3] || (_cache[3] = ($event: any) => ((params.value.pageNum) = $event)),
          pageSize: params.value.pageSize,
          "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((params.value.pageSize) = $event)),
          data: data.value,
          key: num.value,
          behaviorChannel: 7,
          type: "look",
          onSuccess: _cache[5] || (_cache[5] = ($event: any) => (_unref(api)()))
        }, null, 8, ["pageNum", "pageSize", "data"]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _unref(loading)]
  ])
}
}

})